module.exports = __webpack_public_path__ + "img/box-human.334694b5.svg";